import React, { useState, useEffect } from 'react';
import { Column, Notification, Delete } from 'rbx';
import Layout from '../../layout';
import Controls from '../../../components/app/Controls';
import MenuItems from '../../../components/components/MenuItems';

const AppIndexScreen = () => {
  const [message, setMessage] = useState('');
  const [itemSelected, setItemSelected] = useState(null);

  const goToMenu = () => {
    setItemSelected(null);
  }

  const links = [
    { item: <Controls.SetAdmForm setMessage={setMessage} goToMenu={goToMenu} userApp={true} />, description: "Definir usuário como Administrador" },
    { item: <Controls.AppEditForm setMessage={setMessage} goToMenu={goToMenu} />, description: "Editar dados do usuário" },
    { item: <Controls.AppRegisterVehicleForm setMessage={setMessage} goToMenu={goToMenu} />, description: "Registrar um veículo" },
    { item: <Controls.AppStartParkingForm setMessage={setMessage} goToMenu={goToMenu} />, description: "Estacionar um veículo" },
    { item: <Controls.AppRenewParkingForm setMessage={setMessage} goToMenu={goToMenu} />, description: "Renovar um estacionamento" },
    { item: <Controls.AddCadForm setMessage={setMessage} goToMenu={goToMenu} userApp={true} />, description: "Inserção de CADs" },
    //{ item: items.?, description: "Estornar CADs" },
    { item: <Controls.AppPurchaseHistoryList goToMenu={goToMenu} />, description: "Histórico de compras" },
    { item: <Controls.AppParkingHistoryList goToMenu={goToMenu} />, description: "Histórico de uso" },
  ]

  const linksExtras = [
    { url: "/app/find", description: "Localizar outro usuário" },
    { url: "/app/new", description: "Registrar novo usuário" },
  ]

  useEffect(() => {
    if (message!=='')
      setTimeout(() => setMessage(''), 5000);
  }, [message]);

  return (
    <Layout controllerName='App' breadcrumb='Dashbord / App'>
      <Column.Group centered>
        <Column size={4}>
          <Controls.AppDetail />
        </Column>
        <Column>
          { message!=='' && <Notification color={message[0]}><Delete onClick={()=>setMessage('')} /> {message[1]}</Notification> }
          {
            itemSelected ?
              itemSelected :
                <MenuItems setItemSelected={setItemSelected} links={links} linksExtras={linksExtras} />
          }
        </Column>
      </Column.Group>
    </Layout>
  )

}

export default AppIndexScreen;

